import { render, staticRenderFns } from "./awards_list.vue?vue&type=template&id=2dadad48"
import script from "./awards_list.vue?vue&type=script&lang=js"
export * from "./awards_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports